import LBox from "@components/LBox";
import { useTopBarHeight } from "@hooks/useTopBarHeight";

const TopBarPadding = () => {
  const topBarHeight = useTopBarHeight();

  return <LBox height={topBarHeight} width="100%" />;
};

export default TopBarPadding;
